import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import SVGA from 'svgaplayerweb'

import http from 'src/helper/http'
import { jumpToUser } from 'src/helper/webviewFun'
@inject('store')
@observer
export default class EidaAdha extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    rewardRanking: 0, // 新的侠士
    lang: langM.en,
    uid: '',
    language: 'en',
    selecCardItem: 0,
    inWeekIndex: 0,
    showMoldRoot: false,
    dayNum: 0,
    hourNum: 0,
    minNum: 0,
    secondNum: 0,
    rewardIndex: 0,
    giftList: [],
    rewardWcIndex: 0,
    rankingWcIndex: 0,
    intheIndexWc: 0,
    lostTop: [],
    topList: [],
    fasArr: [
      { avatarurl: '/img/icon-bg.png', nickname: 'Yayya', score: 0 },
      { avatarurl: '/img/icon-bg.png', nickname: 'Yayya', score: 0 },
      { avatarurl: '/img/icon-bg.png', nickname: 'Yayya', score: 0 }
    ],
    charmReward: {},
    wealthReward: {},
    showItem: 0,
    wewbase: '',
    showUrl: '',
    myRankListC: {},
    myRankList: {}
  }

  async componentWillMount() {
    // ()
    let { language } = this.props.location.query
    language = await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    setDocumentTitle(this.state.lang.eid_al_adha_events)
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
    this.setState({ uid })
    this.getGiftList()
    this.getCownTime()
    this.getRangkingList()
    this.getWreward()
  }

  componentDidMount() {}

  async getGiftList() {
    let res = await http.post('/web/eidaladha/giftlist')
    console.log(res)
    if (res.code == 0) {
      this.setState({ giftList: res.res })
    }
  }
  score(e) {
    e = parseInt(e || 0)
    if (e > 1000000) {
      e = (parseInt(e / 100000) / 10).toFixed(1) + 'M'
    } else if (e >= 1000) {
      e = (parseInt(e / 100) / 10).toFixed(1) + 'K'
    }
    return e || '--'
  }
  async getCownTime() {
    let res = await http.post('/web/eidaladha/timeinfo')
    if (res.code == 0) {
      this.countDown(res.res.leftTimestamp)
    }
  }

  countDown = (times) => {
    var timer = null
    let { language } = this.state
    timer = setInterval(
      function () {
        var day = 0,
          hour = 0,
          minute = 0,
          second = 0
        if (times > 0) {
          day = Math.floor(times / (60 * 60 * 24))
          hour = Math.floor(times / (60 * 60)) - day * 24
          minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
          second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
        }
        if (day <= 9) day = day
        if (hour <= 9) hour = '0' + hour
        if (minute <= 9) minute = '0' + minute
        if (second <= 9) second = '0' + second
        let daystr = ''
        if (day > 0) {
          // daystr = day
          daystr = day + (language == 'tr' ? ' Gün ' : language == 'ar' ? ' يوم ' : ' days ')
        }
        //time: daystr + hour + ':' + minute + ':' + second
        this.setState({
          dayNum: day,
          hourNum: hour,
          minNum: minute,
          secondNum: second
        })
        times--
      }.bind(this),
      1000
    )
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  handleThisSelect(e) {
    let { rewardWcIndex, rankingWcIndex } = this.state
    this.setState({ rewardRanking: e, intheIndexWc: e == 0 ? rankingWcIndex : rewardWcIndex })
  }

  handleWcFn = (e) => {
    let { rewardRanking } = this.state
    if (rewardRanking == 1) {
      this.setState({ rewardWcIndex: e })
    } else {
      this.setState({ rankingWcIndex: e })
    }
    this.setState({ intheIndexWc: e })
  }

  getName(e) {
    let { language } = this.state
    let name = ''
    if (language == 'en') {
      name = e.rewardName
    } else if (language == 'ar') {
      name = e.rewardNameAr
    } else if (language == 'tr') {
      name = e.rewardNameTr
    }
    return name
  }

  getRangkingList = async () => {
    let { fasArr } = this.state
    let res = await http.post('/web/eidaladha/rank', { rankType: 0 })
    if (res.code == 0) {
      let arr = res.res.list ? res.res.list.slice(0, 3) : fasArr
      if (arr.length < 3) {
        arr = [...arr, ...fasArr]
      }
      let arr2 = res.res.list ? res.res.list.slice(3, 11) : []
      await this.setState({
        topList: [arr],
        lostTop: [arr2],
        myRankList: res.res.mine
      })
    }
    this.getCharmRlist()
  }

  getCharmRlist = async () => {
    let { topList, lostTop, fasArr } = this.state
    let res = await http.post('/web/eidaladha/rank', { rankType: 1 })
    if (res.code == 0) {
      let arr = res.res.list ? res.res.list.slice(0, 3) : fasArr
      if (arr.length < 3) {
        arr = [...arr, ...fasArr]
      }
      let arr2 = res.res.list ? res.res.list.slice(3, 11) : []
      this.setState({
        topList: [...topList, arr],
        lostTop: [...lostTop, arr2],
        myRankListC: res.res.mine
      })
    }
  }

  async getWreward() {
    let res = await http.post('/web/eidaladha/reward', { rankType: 0 })
    if (res.code == 0) {
      this.setState({ wealthReward: res.res })
    }
    this.getCreward()
  }

  async getCreward() {
    let res = await http.post('/web/eidaladha/reward', { rankType: 1 })
    if (res.code == 0) {
      this.setState({ charmReward: res.res })
    }
  }

  handleShow(e) {
    if (!e.preview) return
    let a = e.preview
    let lses = e.preview.split('.')
    this.setState({ showMoldRoot: true, showUrl: a, wewbase: lses[lses.length - 1], showItem: 1 })
    setTimeout(() => {
      new SVGA.autoload(document.querySelector('#show-innew'))
    }, 100)
  }

  getMyRandkIndex(e) {
    let str = ''
    if (e.rankIdx == 0) {
      str = '20+'
    } else if (e.rankIdx >= 20) {
      str = `${20}+`
    } else if (e.rankIdx <= 20) {
      str = e.rankIdx
    }
    return str
  }

  render() {
    let {
      language,
      lang,
      rewardRanking,
      showMoldRoot,
      giftList,
      rankingWcIndex,
      rewardWcIndex,
      intheIndexWc,
      dayNum,
      hourNum,
      minNum,
      secondNum,
      lostTop,
      topList,
      wealthReward,
      charmReward,
      showItem,
      wewbase,
      showUrl,
      myRankList,
      myRankListC
    } = this.state
    return (
      <div className={`eid-al-Adha ${language == 'ar' ? 'arlang' : ''}`}>
        <div
          className="eid-banner"
          style={{
            backgroundImage: `url('/img/activity/eid-al-Adha/eid_banner_${language == 'tr' ? 'new' : language}.png')`
          }}
        >
          <div
            style={{ justifyContent: `${language == 'ar' ? '' : 'flex-end'}` }}
            className="rules_btn"
            onClick={() => this.setState({ showMoldRoot: true, showItem: 0 })}
          >
            <div className="rules_text_img">{lang.rules}</div>
          </div>
        </div>
        <div className="time-root">
          <div className="in-time-item">
            <div className="num-root">{dayNum}</div>
            <div className="text-title">{lang.days}</div>
          </div>
          <div className="in-time-item">
            <div className="num-root">{hourNum}</div>
            <div className="text-title">{lang.hours}</div>
          </div>
          <div className="in-time-item">
            <div className="num-root">{minNum}</div>
            <div className="text-title">{lang.minutes}</div>
          </div>
          <div className="in-time-item">
            <div className="num-root">{secondNum}</div>
            <div className="text-title">{lang.seconds}</div>
          </div>
        </div>
        <div className="eid-gift-root">
          <div className="eid-gift-root-title">
            <div className="textsdse">{lang.event_gifts}</div>
          </div>
          <div className="gift-item">
            {giftList.length > 0 &&
              giftList.map((item, index) => (
                <div className="item" key={index}>
                  <div className="gitf-img-root">
                    <img className="inimg" src={item.image}></img>
                  </div>
                  <div className="gitf-name">
                    <img className="gold-icon" src="/img/activity/eid-al-Adha/gold_icon.png"></img>
                    <div className="name-text">{item.gold}</div>
                  </div>
                </div>
              ))}
          </div>
          <div className="tip-root">{lang.hoby_wish}</div>
        </div>
        <div className="select-ranking-reward">
          <div
            className={`no-select ${rewardRanking == 0 ? 'in-select' : ''}`}
            onClick={() => this.handleThisSelect(0)}
          >
            {lang.ranking}
          </div>
          <div
            className={`no-select ${rewardRanking == 1 ? 'in-select' : ''}`}
            onClick={() => this.handleThisSelect(1)}
          >
            {lang.reward}
          </div>
        </div>
        <div className="chram-wealth">
          <div
            className={`chram ${intheIndexWc == 0 ? 'in-ro-select' : 'no-in-select'}`}
            onClick={() => this.handleWcFn(0)}
          >
            {lang.wealth}
          </div>
          <div
            className={`wealth  ${intheIndexWc == 1 ? 'in-ro-select' : 'no-in-select'} `}
            onClick={() => this.handleWcFn(1)}
          >
            {lang.charm}
          </div>
        </div>
        {rewardRanking == 0 && (
          <div className="ranking_root">
            <div className="ranking-text">
              <div className="intext">{lang.ranking}</div>
            </div>
            {topList[intheIndexWc] && topList[intheIndexWc].length > 0 && (
              <div className="higth-top">
                <div className="top-one-root">
                  <img className="top-one-head" src="/img/activity/eid-al-Adha/top_one_head.png"></img>
                  <div className="top-one-info">
                    <img
                      className="top-one-img"
                      src={topList[intheIndexWc][0].avatarurl || '/img/icon-bg.png'}
                      onClick={() => jumpToUser(topList[intheIndexWc][0].uid)}
                    ></img>
                    <img className="top-icon" src="/img/activity/eid-al-Adha/TOP1.png"></img>
                    <div className="name">{topList[intheIndexWc][0].nickname || 'Yayya'}</div>
                    <div className="rkng-num">
                      <img className="gold-icon" src="/img/activity/eid-al-Adha/gold_icon.png"></img>
                      <div className="num">{this.score(topList[intheIndexWc][0].score || 0)}</div>
                    </div>
                  </div>
                </div>
                <div className="top-two-root">
                  <img className="top-two-head" src="/img/activity/eid-al-Adha/top_two_head.png"></img>
                  <div className="top-two-info">
                    <img
                      className="top-two-img"
                      onClick={() => jumpToUser(topList[intheIndexWc][1].uid)}
                      src={topList[intheIndexWc][1].avatarurl || '/img/icon-bg.png'}
                    ></img>
                    <img className="top-icon" src="/img/activity/eid-al-Adha/TOP2.png"></img>
                    <div className="name">{topList[intheIndexWc][1].nickname || 'Yayya'}</div>
                    <div className="rkng-num">
                      <img className="gold-icon" src="/img/activity/eid-al-Adha/gold_icon.png"></img>
                      <div className="num">{this.score(topList[intheIndexWc][1].score || 0)}</div>
                    </div>
                  </div>
                </div>
                <div className="top-three-root">
                  <img className="top-three-head" src="/img/activity/eid-al-Adha/top_three_head.png"></img>
                  <div className="top-three-info">
                    <img
                      className="top-three-img"
                      onClick={() => jumpToUser(topList[intheIndexWc][2].uid)}
                      src={topList[intheIndexWc][2].avatarurl || '/img/icon-bg.png'}
                    ></img>
                    <img className="top-icon" src="/img/activity/eid-al-Adha/TOP3.png"></img>
                    <div className="name">{topList[intheIndexWc][2].nickname || 'Yayya'}</div>
                    <div className="rkng-num">
                      <img className="gold-icon" src="/img/activity/eid-al-Adha/gold_icon.png"></img>
                      <div className="num">{this.score(topList[intheIndexWc][2].score || 0)}</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {
              <div className="rangking-lost">
                {lostTop[intheIndexWc] &&
                  lostTop[intheIndexWc].length > 0 &&
                  lostTop[intheIndexWc].map((item, index) => (
                    <div
                      className="item-lost"
                      key={index}
                      style={{ [language == 'ar' ? 'paddingLeft' : 'paddingRight']: '0.32rem' }}
                    >
                      <div className="item-lost-left">
                        <div className="num">{item.rankIdx}</div>
                        <div className="info">
                          <img className="atv" src={item.avatarurl} onClick={() => jumpToUser(item.uid)}></img>
                          <div className="name">{item.nickname}</div>
                        </div>
                      </div>
                      <div className="item-lost-right">
                        <img className="gold-icon" src="/img/activity/eid-al-Adha/gold_icon.png"></img>
                        <div className="num">{this.score(item.score)}</div>
                      </div>
                    </div>
                  ))}
              </div>
            }
          </div>
        )}
        {rewardRanking == 0 && intheIndexWc == 0 && (
          <div className="in-the-my">
            <div className="left">
              <div className="num">{this.getMyRandkIndex(myRankList)}</div>
              <div className="user-info">
                <img
                  className="img-atv"
                  onClick={() => jumpToUser(myRankList.uid)}
                  src={myRankList.avatarurl || '/img/icon-bg.png'}
                ></img>
                <div className="name-ew">{myRankList.nickname}</div>
              </div>
            </div>
            <div className="right">
              <img className="gold-icon" src="/img/activity/eid-al-Adha/gold_icon.png"></img>
              <div className="num">{this.score(myRankList.score)}</div>
            </div>
          </div>
        )}
        {rewardRanking == 0 && intheIndexWc == 1 && (
          <div className="in-the-my">
            <div className="left">
              <div className="num">{this.getMyRandkIndex(myRankListC)}</div>
              <div className="user-info">
                <img
                  className="img-atv"
                  onClick={() => jumpToUser(myRankListC.uid)}
                  src={myRankListC.avatarurl || '/img/icon-bg.png'}
                ></img>
                <div className="name-ew">{myRankListC.nickname}</div>
              </div>
            </div>
            <div className="right">
              <img className="gold-icon" src="/img/activity/eid-al-Adha/gold_icon.png"></img>
              <div className="num">{this.score(myRankListC.score)}</div>
            </div>
          </div>
        )}
        {rewardRanking == 1 && (
          <div className="reward-root">
            {rewardWcIndex == 0 && (
              <div className="wealth-reward">
                <div className="top-one-reward">
                  <div className="top-one-reward-text">
                    <div className="textsdse">TOP1</div>
                  </div>
                  {wealthReward.rankReward1 && (
                    <div className="banner-item">
                      <div className="liebw">
                        <img className="banner-img" src={wealthReward.rankReward1[0].pic}></img>
                      </div>
                      <div className="name">{this.getName(wealthReward.rankReward1[0])}</div>
                    </div>
                  )}
                  <div className="root-ow">
                    {wealthReward.rankReward1.length > 0 &&
                      wealthReward.rankReward1.slice(1, 5).map((item, index) => (
                        <div
                          className="item"
                          style={{
                            [index % 2 == 1 && language != 'ar'
                              ? 'marginLeft'
                              : index % 2 == 1 && language == 'ar'
                              ? 'marginRight'
                              : '']: '1.18rem'
                          }}
                        >
                          <div className="item-img" onClick={() => this.handleShow(item)}>
                            <img className="imse-r" src={item.pic}></img>
                            {item.preview && (
                              <img className="open-show-pew" src="/img/activity/eid-al-Adha/show_reward_icon.png"></img>
                            )}
                          </div>
                          <div className="name">{this.getName(item)}</div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="top-two-reward">
                  <div className="top-two-reward-text">
                    <div className="textsdse">TOP2</div>
                  </div>
                  <div className="root-ow">
                    {wealthReward.rankReward2.length > 0 &&
                      wealthReward.rankReward2.slice(0, 4).map((item, index) => (
                        <div
                          className="item"
                          style={{
                            [index % 2 == 1 && language != 'ar'
                              ? 'marginLeft'
                              : index % 2 == 1 && language == 'ar'
                              ? 'marginRight'
                              : '']: '1.18rem'
                          }}
                        >
                          <div className="item-img" onClick={() => this.handleShow(item)}>
                            <img className="img-gift" src={item.pic}></img>
                            {item.preview && (
                              <img className="open-show-pew" src="/img/activity/eid-al-Adha/show_reward_icon.png"></img>
                            )}
                          </div>
                          <div className="name">{this.getName(item)}</div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="top-two-reward">
                  <div className="top-two-reward-text">
                    <div className="textsdse">TOP3</div>
                  </div>
                  <div className="root-ow">
                    {wealthReward.rankReward3.length > 0 &&
                      wealthReward.rankReward3.slice(0, 4).map((item, index) => (
                        <div
                          className="item"
                          style={{
                            [index % 2 == 1 && language != 'ar'
                              ? 'marginLeft'
                              : index % 2 == 1 && language == 'ar'
                              ? 'marginRight'
                              : '']: '1.18rem'
                          }}
                        >
                          <div className="item-img" onClick={() => this.handleShow(item)}>
                            <img className="img-gift" src={item.pic}></img>
                            {item.preview && (
                              <img className="open-show-pew" src="/img/activity/eid-al-Adha/show_reward_icon.png"></img>
                            )}
                          </div>
                          <div className="name">{this.getName(item)}</div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            )}
            {rewardWcIndex == 1 && (
              <div className="charm-reward">
                {Object.keys(charmReward).map((item, index) => (
                  <div className="all-reward">
                    <div className="all-reward-text">
                      <div className="textsdse">{`TOP${index + 1}`}</div>
                    </div>
                    <div className="root-item">
                      {charmReward[item].map((item, index) => (
                        <div className="item" key={index}>
                          <div className="item-img" onClick={() => this.handleShow(item)}>
                            <img className="imgss" src={item.pic}></img>
                            {item.preview && (
                              <img className="open-show-pew" src="/img/activity/eid-al-Adha/show_reward_icon.png"></img>
                            )}
                          </div>
                          <div className="name">{this.getName(item)}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        <div className="activity-tips">
          <div className="opew">{lang.eid_al_adha_events_button_introduction_1}</div>
          <div className="opw">{lang.eid_al_adha_events_button_introduction_2}</div>
        </div>
        {showMoldRoot && (
          <div className="show-rules-modle" onClick={() => this.setState({ showMoldRoot: false, showItem: 0 })}>
            <div>
              {showItem == 0 && (
                <div className="rules-root" onClick={(e) => e.stopPropagation()}>
                  <div className="rules-conntr-text">
                    <div className="textsdse">{lang.rules}</div>
                  </div>
                  <div className="rules-connten-text">
                    <div>{lang.rules_description1}</div>
                    <div>{lang.rules_description2}</div>
                    <div>{lang.rules_description3}</div>
                    <div>{lang.rules_description4}</div>
                    <div>{lang.rules_description5}</div>
                    <div>{lang.rules_description6}</div>
                  </div>
                </div>
              )}
              {showItem == 1 && (
                <div className="show-gift-show" onClick={(e) => e.stopPropagation()}>
                  {wewbase == 'svga' && (
                    <div
                      className="show-innew"
                      id="show-innew"
                      src={showUrl}
                      onClick={(e) => e.stopPropagation()}
                    ></div>
                  )}
                  {wewbase == 'mp4' && (
                    <video
                      className="show-innew"
                      autoPlay
                      loop
                      muted
                      play="true"
                      playsInline={true}
                      webkit-playsinline="true"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <source src={showUrl} type="video/mp4" />
                    </video>
                  )}
                </div>
              )}
              <img
                className="cloes-img-fn"
                style={{ [language == 'ar' ? 'marginRight' : 'marginLeft']: '2.8rem' }}
                onClick={() => this.setState({ showMoldRoot: false })}
                src="/img/activity/eid-al-Adha/intheclose.png"
              ></img>
            </div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/eid-al-Adha/index.js